import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import PermissionsEditForm from './PermissionsEditForm';

const PermissionsEdit = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Permission" title="Edit permission" subParent="Permissions" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Edit role</H5>
                <Link to="/permissions">
                  <Btn color="primary">Back to permissions</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <PermissionsEditForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Create</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PermissionsEdit;
